import BigNumber from 'bignumber.js';

import { api } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { getPoolShares } from 'modules/ownerPanel/methods/getPoolShares';

export const { useGetPoolSharesQuery } = api.injectEndpoints({
  endpoints: build => ({
    getPoolShares: build.query<BigNumber, void>({
      queryFn: async () => {
        const client = getPublicClient();

        return {
          data: await getPoolShares(client),
        };
      },
    }),
  }),
});
